import React from 'react';

import Layout from '@components/Layouts/Layout';
import SEO from '@components/Layouts/SEO';
import { YandexTableau } from '@components/Layouts/YandexTableau';

import GiftPage from '@components/GiftPage/GiftPage';

export function Head() {
  return (
    <>
      <SEO
        title="Сертификат на фотокнигу: изготовление и печать фотокниг в подарок"
        description="Закажите универсальный подарок для коллег, друзей и родных: электронный сертификат на фотокнигу! Порадуйте близких фотоальбомом на заказ из собственных фотографий!"
      />
      <YandexTableau />
    </>
  );
}

export default function Gift() {
  return (
    <Layout>
      <GiftPage />
    </Layout>
  );
}
